import * as Yup from "yup";

export const departmentValidationSchema = Yup.object().shape({
	teamName: Yup.string().required("Team name is required"),
});
